import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-2d5cc296")

_pushScopeId("data-v-2d5cc296")
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "form" }
const _hoisted_3 = { class: "btns" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 設定")
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" キャンセル")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_switch = _resolveComponent("el-switch")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form = _resolveComponent("el-form")
  const _component_cus_panel = _resolveComponent("cus-panel")
  const _component_el_button = _resolveComponent("el-button")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_cus_panel, null, {
        default: _withId(() => [
          _createVNode(_component_el_form, {
            model: _ctx.form,
            size: "small",
            "label-position": "top"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_form_item, {
                label: "メンテナンスのお知らせを表示する",
                prop: "menteHyoujiFlg",
                class: "entire-row"
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_switch, {
                    modelValue: _ctx.form.menteHyoujiFlg,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.menteHyoujiFlg = $event)),
                    id: "menteHyoujiFlg"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "メンテナンス通知情報 タイトル",
                prop: "menteTitle",
                class: "entire-row"
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_input, {
                    type: "text",
                    modelValue: _ctx.form.menteTitle,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.menteTitle = $event)),
                    id: "menteTitle"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_form_item, {
                label: "メンテナンス・障害情報",
                prop: "menteComment",
                class: "entire-row"
              }, {
                default: _withId(() => [
                  _createVNode(_component_el_input, {
                    type: "textarea",
                    autosize: { minRows: 12 },
                    modelValue: _ctx.form.menteComment,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.menteComment = $event)),
                    id: "menteComment"
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["model"])
        ]),
        _: 1
      })
    ]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", null, [
        _createVNode(_component_el_button, {
          class: "update-btn",
          type: "primary",
          size: "medium",
          plain: "",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleUpdate())),
          loading: _ctx.updateBtnLoading
        }, {
          default: _withId(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["loading"])
      ]),
      _createVNode("div", null, [
        _createVNode(_component_el_button, {
          class: "cancel-btn",
          size: "medium",
          plain: "",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleCancel()))
        }, {
          default: _withId(() => [
            _hoisted_5
          ]),
          _: 1
        })
      ])
    ])
  ]))
})